import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedinIn, FaTwitter, FaEnvelope } from 'react-icons/fa';

const TeamCard = ({ member, index = 0 }) => {
  const cardVariants = {
    hidden: { 
      opacity: 0, 
      y: 30 
    },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
        delay: index * 0.1
      }
    }
  };

  const imageVariants = {
    hover: {
      scale: 1.1,
      transition: {
        duration: 0.4,
        ease: 'easeInOut'
      }
    }
  };

  const socialVariants = {
    hidden: { opacity: 0, y: 10 },
    hover: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.3,
        staggerChildren: 0.1
      }
    }
  };

  return (
    <motion.div
      className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
      variants={cardVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-50px" }}
    >
      {/* Image Container */}
      <div className="relative h-80 overflow-hidden bg-gray-100">
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent z-10 opacity-60 group-hover:opacity-40 transition-opacity duration-300" />
        
        <motion.img 
          src={member.image} 
          alt={member.name}
          className={`w-full h-full object-cover ${member.objectPosition || 'object-top'}`}
          variants={imageVariants}
          whileHover="hover"
        />

        {/* Social Links Overlay */}
        <motion.div 
          className="absolute bottom-0 left-0 right-0 p-6 z-20 translate-y-4 group-hover:translate-y-0 transition-transform duration-300"
        >
           {/* Placeholder for social links if needed in future, keeping it clean for now as per reqs */}
           <div className="flex space-x-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100">
             {/* Example utility buttons */}
             {/* <button className="w-8 h-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white hover:text-blue-600 transition-colors">
               <FaLinkedinIn size={14} />
             </button> */}
           </div>
        </motion.div>
      </div>

      {/* Content */}
      <div className="p-6 text-center relative z-20 bg-white">
        <h3 className="text-xl font-bold text-gray-800 mb-1 group-hover:text-blue-600 transition-colors duration-300">
          {member.name}
        </h3>
        {member.role && (
          <p className="text-sm font-medium text-blue-500 uppercase tracking-wider">
            {member.role}
          </p>
        )}
        
        {/* Decorative element */}
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      </div>
    </motion.div>
  );
};

export default TeamCard;
